import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconStage: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="stage, show"><path fillRule="evenodd" clipRule="evenodd" d="M2 5.75C2 4.7835 2.7835 4 3.75 4H20.25C21.2165 4 22 4.7835 22 5.75V18.25C22 19.2165 21.2165 20 20.25 20H3.75C2.7835 20 2 19.2165 2 18.25V5.75ZM20.3938 18.4545L17.5081 15.5731C17.4613 15.5263 17.3977 15.5 17.3315 15.5H6.66421C6.59791 15.5 6.53432 15.5263 6.48744 15.5732L3.60616 18.4545C3.64684 18.4832 3.69645 18.5 3.75 18.5H20.25C20.3035 18.5 20.3531 18.4832 20.3938 18.4545Z" fill="currentColor"/></CentralIconBase>;
};

export default IconStage;
